import { createFileRoute } from '@tanstack/react-router';
import { MonitoringPage } from '@/features/tenant-admin/pages';

export const Route = createFileRoute('/tenant-admin/monitoring')({
  component: MonitoringPage,
});
